module.exports = __webpack_public_path__ + "img/frame (117).3878f62c.jpg";